/** @file A fresh, never-advanced track entry with Pose2D's documented defaults. */
import type { TrackEntry } from '../contracts/state';

/**
 * lastTime -1 marks "never advanced" (stepState then emits interrupt(from) and start); timeScale 1, alpha 1,
 * replace, no from, no mixDirs and no owner (CR-019); eventThreshold 0 (a fading-out entry fires no events); attachment and
 * draw-order thresholds 0.5 (discrete channels switch mid-fade, W2-07).
 */
export function newTrackEntry(anim: number, loop: boolean, mixDuration: number, delay: number): TrackEntry {
  return {
    anim, loop, time: 0, lastTime: -1, timeScale: 1, delay, alpha: 1, blend: 'replace', mixDuration, mixTime: 0,
    from: null, mixDirs: null, owner: null, eventThreshold: 0, attachmentThreshold: 0.5, drawOrderThreshold: 0.5,
  };
}
